module.exports = __webpack_public_path__ + "media/images/case-studies/longley-fe14900fbc8abb71fc5150ba87894c43.png";